import { cn } from "../../../Pages/Main/Retailer/Invoice/invoiceUtils";

export function InternalButton({ onClick, label = "View Details", size = "md" }) {
  const pad = size === "sm" ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm";
  return (
    <button
      onClick={onClick}
      className={cn(
        "inline-flex items-center justify-center rounded-2xl bg-white border border-slate-200 text-slate-900 font-extrabold hover:bg-slate-50",
        pad
      )}
    >
      {label}
    </button>
  );
}